import { useMemo } from 'react';
import { sortGroups, sortWorklogs } from '../utils/sortingUtils';

/**
 * Custom hook to sort grouped worklogs
 * 
 * @param {Object} groupedWorkLogs - The grouped worklogs object
 * @param {Object} sorting - Sorting configuration with groupLevel and withinGroup
 * @param {string} groupingField - The current grouping field
 * @param {Array} filteredWorkLogs - Filtered worklogs (only used when groupingField === 'none')
 * @returns {Object} - Sorted grouped worklogs
 * 
 */
const useSortedGroups = (groupedWorkLogs, sorting, groupingField, filteredWorkLogs) => {
  return useMemo(() => {
    // Early return for ungrouped view
    if (groupingField === 'none') {
      return { ungrouped: filteredWorkLogs };
    }

    // Convert to array of [key, group] tuples for sorting
    const groups = Object.entries(groupedWorkLogs);

    // Sort groups by group-level criteria
    const sortedGroups = sortGroups(groups, sorting.groupLevel, groupingField);

    // Sort worklogs within each group
    const sortedGroupsWithWorklogs = sortedGroups.map(([key, group]) => {
      if (group.logs && Array.isArray(group.logs)) {
        return [key, { ...group, logs: sortWorklogs(group.logs, sorting.withinGroup) }];
      }
      return [key, group];
    });

    return Object.fromEntries(sortedGroupsWithWorklogs);
  }, [groupedWorkLogs, sorting, groupingField, filteredWorkLogs]);
};

export default useSortedGroups;

